<template>
  <div class="q-img-container main-color">
    <label class="label q-label">
      {{question.q}}
      <div class="btn-location">
        <md-button style="margin:auto" 
          v-if="!(readOnly || (answer.latitude != null && answer.longitude != null))" 
          v-on:click="getCurrentLocation" 
          class="md-round md-sm md-green"
        >
        Obtener Ubicación
        </md-button>
        <div class="btn-location-warning" v-if="errorStr!=null">
        {{ errorStr }}
        </div>
      </div>
    </label>
  <div class="map-container">
      <div class="map panel" id="map-panel" ref="mapPanel"></div>
      <div class="map-error map-info-panel overlay" v-if="mapError">
        <h2>
          <md-icon class="md-size-2x">
            error
          </md-icon>
          Error cargando capa
        </h2>
      </div>
    </div>
  </div>
</template>

<script>

import { loadModules } from 'esri-loader';

export default {
  name: "location-question",
  props: {
    question: {
      type: Object,
      default: () => {
        return {};
      }
    },
      answerProp: {
        type: Object,
        default: () => ({
          longitude: null,
          latitude: null
        })
      },
      readOnly: {
        type: Boolean,
        default: false
      },
      surveyIdProp:{
        type: String,
        default: "test"
      }
  },
  data: function() {
    return {
      gettingLocation: false,
      errorStr:null,
      answer: this.answerProp,
      disabled: this.readOnly,
      resultId: "",
      urlComentarios: "",
      image: null,
      image_: null,
      imageName: null,
      file_: null,
      filename: null,
      loading: false,
      mapERror: false,
      map: null, 
      view: null,
      graphicsLayer: null,
    };
  },
  watch: {
    // cada vez que la pregunta cambie, esta función será ejecutada
    answer: function (newQuestion, oldQuestion) {
      this.emitValue()
    }
  },
  methods: {
    emitValue: function() {
      //console.log(this.answer);
      this.$emit("emit-value", { "q_id": this.question.q_id, "q_type": this.question.q_type, "ans": this.answer });
    },
    getCurrentLocation: function() {

      this.gettingLocation = true;
      this.errorStr = null;
      // get position
      navigator.geolocation.getCurrentPosition(pos => {
        this.gettingLocation = false;
        this.answer = {longitude: pos.coords.longitude, latitude: pos.coords.latitude};
        this.updateMarkerOnMap(this.answer)
        
        }, err => {
          this.gettingLocation = false;
          // this.errorStr = err.message;
          this.errorStr = '* Debe habilitar su ubicación en el navegador';
        }
      );
    },
    updateMarkerOnMap (position) {
      this.view.center = [position.longitude, position.latitude];
      this.view.zoom = 15;

      loadModules(
          [
          "esri/Graphic",
          "esri/symbols/TextSymbol"
          ], {
            url: 'https://js.arcgis.com/4.17/'
          }
        ).then(
          ([
            Graphic, TextSymbol
          ]) => {
            this.graphicsLayer.add(new Graphic({
              geometry: {
                type: "point",
                longitude: position.longitude,
                latitude: position.latitude
              },
              symbol: {
                type: "simple-marker",
                color: "red",
                outline: {
                    color: [255, 255, 255], // White
                    width: 1
                }
              }
            }));
            this.graphicsLayer.add(new Graphic({
              geometry: {
                type: "point",
                longitude: position.longitude,
                latitude: position.latitude
              },
              symbol: new TextSymbol({
                color: "black",
                haloColor: "white",
                haloSize: "5px",
                text: `${position.longitude}, ${position.latitude}`,
                yoffset: 10,
              })
            }));
          }
        );
    }
  },
  mounted: function() {

    loadModules(
      [
        "esri/Map",
        "esri/views/MapView",
        "esri/layers/GraphicsLayer"
      ], {
        url: 'https://js.arcgis.com/4.17/'
      }
    ).then(
      ([
        Map, MapView, GraphicsLayer
      ]) => {
        this.map = new Map({
          basemap: "osm"
        });

        this.view = new MapView({
          container: "map-panel",
          map: this.map,
          center: [-90.522713,14.628434],
          zoom: 12
        });
        
        this.view.on("mouse-wheel", (event) => {
          // prevents zooming with the mouse-wheel event
          event.stopPropagation();
        });

        this.graphicsLayer = new GraphicsLayer();
        this.map.add(this.graphicsLayer);
      }
    );
    if (this.answer.latitude != null && this.answer.longitude != null) {
      this.updateMarkerOnMap(this.answer)
    }
  }
};
</script>

<style lang="scss" scoped>
@import url('https://js.arcgis.com/4.17/esri/themes/light/main.css');
@import "../../assets/scss/md/variables";

.esri-gt-map-panel {
  height: 100%;

  .map-container {
    position: relative;
    height: calc(100% - 60px);
    .map {
      height: 100%;

      /deep/ {
        .esri-popup__inline-actions-container:only-child {
          &>.esri-popup__action,
          &>.esri-popup__action-toggle {
            max-width: 100%;
          }
        }

        .esri-view-surface {
          width: 200%;
        }

        .esri-popup__content {
          max-height: 100px;
        }

        .esri-ui {
          overflow: visible;
        }

        .esri-popup__header-title {
          font-weight: bold;
        }

        .esri-view-user-storage {
          display: none;
        }

      }
    }

    .overlay {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0; 
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0,0,0,0.5);
      z-index: 2;
    }

    .map-info-panel {
      display: flex;
      justify-content: center;
      align-items: center;

      h2 {
        color: $white;
      }
    }

    .map-error {
      i.md-icon {
        color: $brand-warning;
        position: relative;
        top: -3px;
      }
    }
  }
}
</style>

<style>
.esri-view-user-storage {
  display: none !important;
}
.esri-widget--button {
  display: none !important;
}
</style>
